module.exports = "pegasus/assets/blocks/column-15-theme4.png";